{
  "page": "loan-consent",
  "next": "/loan-consent",
  "options": [],
  "params": [],
  "session": {
    "ecodes": [],
    "address_suggestions": [],
    "supplier_code": "TEST-SUPPLIER-123456",
    "points": [],
    "order_id": "test-order-id-123",
    "cbi_questions": [],
    "required_keys": [],
    "common_docs": {
      "til": {
        "date": "2022-03-10",
        "title": "Truth In Lending Disclosure",
        "url": "https://fps6.dev.uplift-platform.com/docs/v1/up-play-us-east-1-kasa/docs/41417c38e59314e53add46e5f3f366840a06b447bfd155a5b8919da38c9a69a2.html"
      },
      "bapn": {
        "date": "2022-03-10",
        "title": "Borrower Agreement and Promissory Note",
        "url": "https://fps6.dev.uplift-platform.com/docs/v1/up-play-us-east-1-kasa/docs/45f976a05e30dc411bbc1cff03d7a8b6d56cfb228827f8e4699baf07f29c25c7.html"
      },
      "dcd": {
        "date": "2022-03-10",
        "title": "Recurring Electronic Payment Authorization",
        "url": "https://fps6.dev.uplift-platform.com/docs/v1/up-play-us-east-1-kasa/docs/9cde795d5c27368cec554db5c9a1036aae4f9b491d967d9a4f46df299eab553f.html"
      },
      "localization": {
        "country": "US",
        "language": "en",
        "currency": "USD"
      },
      "csd": {
        "date": "2022-03-10",
        "title": "Credit Score Disclosure",
        "url": "https://fps6.dev.uplift-platform.com/docs/v1/up-play-us-east-1-kasa/docs/716ef06ea20a2a732c60b28e8ebeaa9337a3b97133bef0c09f1615eeb2a6f268.html"
      },
      "ps": {
        "date": "2022-03-10",
        "title": "Payment Schedule",
        "url": "https://fps6.dev.uplift-platform.com/docs/v1/up-play-us-east-1-kasa/docs/112402c2895d2a67e72ca4057536bed28d98b692e0a8280edcd46902d582781a.html"
      },
      "wd": {
        "date": "2022-03-10",
        "title": "Wisconsin Disclosure",
        "url": "https://www.upgrade.com/state-disclosures/wisconsin/"
      }
    },
    "loan_offers": [
      {
        "origination_fee": 1457,
        "total_interest": 4139,
        "offer_id": "TEST-OFFER-ID-123",
        "pay_today": 5676,
        "promos": [],
        "finance_charges": 5596,
        "apr": 1505,
        "down_payment": 5676,
        "localization": {
          "country": "US",
          "language": "en",
          "currency": "USD"
        },
        "monthly_payment_amount": 7133,
        "pure_down_payment": 4219,
        "payment_due_day": 14,
        "grand_total": 85596,
        "loan_amount": 74324,
        "total_payments": 78463,
        "order_amount": 80000,
        "financed_amount": 72867,
        "number_of_payments": 11
      }
    ]
  },
  "order_info": {
    "event_tickets": [],
    "rentals": [],
    "travelers": [
      {
        "id": 0,
        "first_name": "Arthur",
        "last_name": "Davis",
        "date_of_birth": "04/07/1963"
      }
    ],
    "billing_contact": {
      "email": "arthur@uplift.com",
      "first_name": "Arthur",
      "phone": "5555559075",
      "last_name": "Davis"
    },
    "hotel_reservations": [],
    "started_at": "2021-12-14",
    "industry": "travel",
    "sequence_id": "TEST-SEQUENCE-ID-123",
    "localization": {
      "country": "US",
      "language": "en",
      "currency": "USD"
    },
    "supplier_code": "TEST-SUPPLIER-123456",
    "points": [],
    "add_ons": [],
    "up_code": "UP-123456",
    "air_reservations": [],
    "order_id": "test-order-id-123",
    "order_lines": [],
    "cruise_reservations": [
      {
        "rooms": [
          {
            "cabin_type": "6V (Interior)",
            "state_room_type": "6V (Interior)",
            "state_room_number": "7447"
          }
        ],
        "embark_date": "20221229",
        "insurance": [
          {
            "types": ["cancellation"],
            "price": 10000
          }
        ],
        "cruise_line": "Royal Caribbean",
        "cruise_duration": 3,
        "add_ons": [],
        "disembark_date": "20230103",
        "itinerary": [
          {
            "departure_port": "Port Canaveral (Orlando), Florida",
            "departure_date": "20221229",
            "arrival_date": "20230103",
            "activities": []
          }
        ],
        "price": 120041,
        "traveler_ids": []
      }
    ],
    "order_amount": 80000,
    "customer_id": ""
  }
}
